//-------------- IMPORTAÇÕES --------------//
import { useContext } from "react";
import { EmpresasContext } from "../context/EmpresasContext";
import { LoadingContext } from "../../../shared/context/LoadingContext";
import { disableCompanyService, loadCompaniesService } from "../services";



//-------------- EXPORTAÇÃO DO COMPONENTE TABLE COMPANIES --------------//
export default function TableCompanies() {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const { empresas, setEmpresas } =  useContext(EmpresasContext);
    const { formData, setFormData } = useContext(EmpresasContext);
    const { isEditing, setIsEditing } = useContext(EmpresasContext);
    const { editedCompanyId, setEditedCompanyId } = useContext(EmpresasContext);
    const { isLoading, setIsLoading } = useContext(LoadingContext);



    //--------------- FUNÇÃO ASSÍNCRONA HANDLE REFRESH COMPANIES ---------------//
    async function handleRefreshCompanies() {
        setIsLoading(true);
        const response = await loadCompaniesService();
        if (response) {
            setEmpresas(response.data);
        }
        setIsLoading(false);
    }



    //--------------- FUNÇÃO HANDLE MODAL EDIT ---------------//
    // Responsável por abrir o Modal de Edição e armazenar as informações da empresa que está sendo editada
    // Armazena true no Estado "isEditing", pois agora o usuário está editando
    // Armazena no Estado "editingId" o ID da Empresa que está sendo editada
    const handleModalEdit = (empresa) => {
        setFormData({
            nome: empresa.nome || "",
            descricao_negocio: empresa.descricao_negocio || "",
        });
        setIsEditing(true);
        setEditedCompanyId(empresa.id);
    };



    //--------------- FUNÇÃO ASSÍNCRONA INATIVAR EMPRESA ---------------//
    // Responsável por requisitar à API a inativação da Empresa escolhida
    // Por fim, atualiza a lista de empresas
    async function handleDisableCompany(id) {
        const response = disableCompanyService(id);
        if (response) {
            handleRefreshCompanies();
        }
    };



    //-------------- RETORNO DO COMPONENTE TABLE COMPANIES --------------//
    return (
        <>

            {/* DIV DA TABELA DE EMPRESA */}
            <div className="bg-surface-2 rounded-xl overflow-hidden shadow border border-white/[0.08]">

                {/* TABELA */}
                <table className="w-full text-xs sm:text-sm">

                    {/* CABEÇALHO DA TABELA */}
                    <thead className="bg-surface-3">
                        <tr>
                            <th className="p-3 text-left">ID</th>
                            <th className="p-3 text-left">Nome</th>
                            <th className="p-3 text-left hidden sm:table-cell">Ações</th>
                        </tr>
                    </thead>

                    {/* CORPO DA TABELA */}
                    <tbody>
                        {empresas.map((empresa) => (
                            <>

                                <tr key={empresa.id} className="sm:border-b sm:border-white/[0.08]">
                                    <td className="p-3">{empresa.id}</td>
                                    <td className="p-3">{empresa.nome}</td>
                                    <td className="p-3 hidden sm:table-cell">
                                        <div className="flex flex-col sm:flex-row gap-2">
                                            <button
                                                onClick={() => handleModalEdit(empresa)}
                                                className="bg-blue-600 hover:bg-blue-700 px-3 py-1 rounded"
                                            >
                                                Editar
                                            </button>
                                            <button
                                                onClick={() => handleDisableCompany(empresa.id)}
                                                className="bg-red-600 hover:bg-red-700 px-3 py-1 rounded"
                                            >
                                                Inativar
                                            </button>
                                        </div>
                                    </td>
                                </tr>

                                {/* BUTTONS PARA SMARTPHONE */}
                                <tr className="sm:hidden border-b border-white/[0.08]">
                                    <td colSpan={2}>
                                        <div className="flex flex-row gap-2 items-center text-right p-3">
                                            <button
                                                onClick={() => handleModalEdit(empresa)}
                                                className="block ml-auto bg-blue-600 hover:bg-blue-700 px-3 py-1 rounded"
                                            >
                                                Editar
                                            </button>
                                            <button
                                                onClick={() => handleDisableCompany(empresa.id)}
                                                className="block bg-red-600 hover:bg-red-700 px-3 py-1 rounded"
                                            >
                                                Inativar
                                            </button>
                                        </div>
                                    </td>
                                </tr>


                            </>
                        ))}
                    </tbody>

                </table>

            </div>

        </>
    )
}